// Ocasionally the API sends some "0001-01-01T00:00:00" date/times and the carrier portal takes those and displays them, then when the customer updates they're submitted back to the DB.  Filtering them out there both before displaying and before

// DateChecker returns true if the date isn't a bad date, false if it is a bad date
export const DateChecker = date => {
  if (date === "0001-01-01T00:00:00") {
    return false;
  } else {
    return true;
  }
};

// Returns { tooOld: true, field, value } if any non-empty date in the dates object
// is more than 365 days in the past, otherwise { tooOld: false }.
export const isShipmentTooOldToUpdate = (dates) => {
  if (!dates || typeof dates !== 'object') return { tooOld: false };
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - 365);
  for (const [field, value] of Object.entries(dates)) {
    if (!value || value === '') continue;
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) continue;
    if (parsed < cutoff) {
      console.log(`isShipmentTooOldToUpdate: field "${field}" has value "${value}" which is older than 365 days`);
      return { tooOld: true, field, value };
    }
  }
  return { tooOld: false };
};

export default DateChecker;
